module.exports = __webpack_public_path__ + "img/close.84b61243.svg";